<button type="button" class="btn btn-ghost-info waves-effect waves-light">
	<i class="las la-pencil-alt"></i>
</button>
